import { combineEpics } from 'redux-observable';

import { _reducer } from './CampusGroups.reducers';
import _epics from './CampusGroups.epics';

export const epics = combineEpics(_epics);

export { _reducer };
export * from './CampusGroups.actions';
